export const classicNavy = {
  id: 'classic-navy',
  name: 'Classic Navy',
  isDark: false,
  variables: {
    '--font-family-primary': 'Georgia, "Times New Roman", serif',
    '--font-family-secondary': 'Arial, Helvetica, sans-serif',
    '--color-primary': '#16324F',      // Deep Corporate Navy
    '--color-secondary': '#204F73',    // Steel Blue
    '--color-accent': '#D38B27',       // Gold Accent
    '--color-bg-page': '#FFFFFF',      // Pure White Paper
    '--color-text-main': '#2F2F2F',    // Charcoal Dark Text
    '--color-text-light': '#777777',   // Gray Meta Text
    '--color-border': '#E2E8F0',       // Light border gray
    '--spacing-multiplier': '1.0',
    '--heading-text-transform': 'none',
    '--heading-letter-spacing': 'normal',
    '--bullet-style': 'circle',
  }
};
